exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.headers[data-v-42bc5771] {\n  display: grid;\n  grid-template-columns: 5fr repeat(4, 1fr) 16px;\n  grid-gap: 16px;\n  font-family: 'Roboto Mono', monospace;\n  font-size: 12px;\n  text-align: right;\n  margin-bottom: 16px;\n}\n.headers .size-field[data-v-42bc5771]:first-letter {\n  text-transform: uppercase;\n}\n", ""]);

// exports
